<template>
  <v-app class="po-layout-page">
    <PurchaseOrderBase
      :isShippingLabel="true"
    >
      <template v-slot:left="left">
        <PoLineItemsList
          :loading="loading"
          :lineSelectionDisabled="currentLineInfoLoading || actionsDisabled"
          :currentLineInfoLoading="currentLineInfoLoading"
          :items="poLineItems"
          :groupedItems="groupedLineItems"
          :poNumber="poNumber"
          @po-line-item-selected="currentLineItemChanged"
          :show="left.showPoLineItemsList"
          @visibility-changed="left.onListVisibilityChanged"
          :routeName="'purchaseOrderShippingLabel'"
        />
      </template>
      <slot/>
    </PurchaseOrderBase>
    <SatFooter />
  </v-app>
</template>

<script>

import SatFooter from '@/components/common/Footer.vue';
import PurchaseOrderBase from '@/layouts/PurchaseOrderBase.vue';
import PoLineItemsList from '@/components/PoDetails/SideBar/PoLineItemsList.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import PoDetailsConstants from '@/store/modules/poDetails/constants';
import SnackbarConstants from '@/store/modules/snackbarNotification/constants';

export default {
  components: {
    PoLineItemsList,
    PurchaseOrderBase,
    SatFooter,
  },
  computed: {
    ...mapState({
      loading: state => state.poDetails.loading,
      actionsDisabled: state => state.poDetails.actionsDisabled,
      clients: state => state.poDetails.clients,
      poNumber: state => state.poDetails.poNumber,
      poLineItems: state => state.poDetails.lineItems,
      groupedLineItems: state => state.poDetails.groupedLineItems,
      currentLineInfoLoading: state => state.poDetails.approvedImagesLoading
                                    || state.poDetails.uploadedImagesLoading
                                    || state.poDetails.activityLoading,
    }),
    ...mapGetters('poDetails', {
      imagesCount: PoDetailsConstants.getterTypes.currentLineItemImagesCount,
      currentLineItem: PoDetailsConstants.getterTypes.currentLineItemInfo,
    }),
    currentUrl() {
      return this.$route.fullPath;
    },
  },
  methods: {
    getCurrentLineItemId() {
      return this.currentLineItem.lineItems[0].id;
    },
    ...mapActions('poDetails', {
      currentLineItemChanged: PoDetailsConstants.actionTypes.onCurrentLineItemChanged,
      updateLineItemsStatus: PoDetailsConstants.actionTypes.updateLineItemsStatus,
      getApprovalDocument: PoDetailsConstants.actionTypes.getApprovalDocument,
      reportIssue: PoDetailsConstants.actionTypes.reportIssue,
    }),
    ...mapActions('snackbarNotification', {
      successNotification: SnackbarConstants.actionTypes.success,
    }),
  },
};
</script>

<style lang="scss">
  .po-layout-page{
    main{
      background: #f2f2f2;
    }

    .po-toolbar-title {
      width: 100%;
    }
  }

  .v-toolbar__extension {
    background: #039BE5;
  }
</style>
